import axios from "axios";

export const fetchGetTaskCounterJobTitles = async (organizationId: string) => {
  const baseTaskUrl = process.env.REACT_APP_TASK_API_URL;
  return await axios.get(`${baseTaskUrl}/TaskCounterTemplate/job-titles/${organizationId}`);
};
